export default __webpack_public_path__ + "static/media/ost-why-buy-bg_optim.48d7392c.jpg";